import config from "../../config";
import Sidebar from "../../components/partials/Sidebar";
import Header from "../../components/partials/Header";
import Breadcrumb from "../../components/Breadcrumb";
import { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import "./style.css";
import moment from "moment";
import $ from "jquery";
import { millionComma, removeMillionComma } from "../../utils";
import { BiCreditCard } from "react-icons/bi";
import PayDtlCard from "../../components/PayDtlCard";

function ExpenseView(props) {
  const { id } = useParams();
  const location = useLocation();
  let filter = location.state?.currentFilter;
  let currentFilterState = location.state?.showFilter;
  let page = location.state?.currentPageNo;
  const [expense, setExpense] = useState(location.state?.expense || []);

  const [formInputs, setFormInputs] = useState(() => {
    // Parse pay_dtl if it exists
    const updatedExpense = {
      ...expense,
      pay_dtl: expense?.pay_dtl ? JSON.parse(expense.pay_dtl) : null,
    };
    return updatedExpense;
  });

  // console.log("formInputsformInputsformInputsformInputs", formInputs)
  const [user, setUser] = useState({});

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  useEffect(
    function () {
      if (expense.length == 0) {
        $.post(
          `${config.apiUrl}/expense/listExpense`,
          JSON.stringify({ exp_hdr_id: id }),
          function (res) {
            setExpense(res?.data?.list?.[0] || []);
          }
        );
      }
    },
    [expense]
  );

  const [showPayDtl, setShowPayDtl] = useState(false);
  const handlePayDtl = () => {
    setShowPayDtl((prevState) => !prevState);
  };

  function getPaymentMode() {
    const paymentModes = formInputs.pay_dtl.filter(
      (pay) => pay.amt !== "" && pay.amt !== undefined && pay.amt > 0
    );

    if (paymentModes.length === 0) {
      return "Cash UGX";
    } else if (paymentModes.length === 1) {
      return paymentModes[0].mode;
    } else {
      return "Multiple";
    }
  }

  console.log("expsnenefg", expense);
  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div
          className="content m-1 p-2 position-relative"
          style={{ paddingBottom: "8rem" }}
        >
          <Header />
          <Breadcrumb path={["Expense", "View Expense"]} />

          <main className="bg-white rounded-2" id="expenseAdd">
            <div className="container-fluid p-2 position-relative">
              <Link
                to="/expense"
                className="position-absolute text-decoration-none small"
                style={{ top: "-1.5rem", right: "0" }}
                state={{
                  backToCurrent: page,
                  appliedFilter: filter,
                  filterDisplay: currentFilterState,
                }}
              >
                Go Back to List
              </Link>
              <form className="row gx-4 gy-2 mt-2" autoComplete="off">
                <div className="col-md-3">
                  <label htmlFor="Expense_Type">Expense Type </label>
                  <input
                    type="text"
                    className="form-control"
                    id="exp_type"
                    value={
                      config.expenseCategories.find(
                        (t) => t.value == expense.exp_type
                      )?.label || "N/A"
                    }
                    disabled
                  />
                </div>
                {[1, 2].includes(Number(expense?.exp_type)) && (
                  <div className="col-md-3">
                    <label htmlFor="exp_cat_id">Expense Category</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exp_cat_id"
                      value={expense.exp_cat_name}
                      disabled
                    />
                  </div>
                )}
                {expense?.exp_type == 3 && (
                  <div className="col-md-3">
                    <label htmlFor="narration">Cashier Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="cashier_name"
                      value={expense?.cashier_name}
                      disabled
                    />
                  </div>
                )}
                <div className="col-md-3">
                  <label htmlFor="dt_of_exp">Expense Date</label>
                  <input
                    type="date"
                    className="form-control"
                    id="dt_of_exp"
                    value={moment(expense.dt_of_exp).format("YYYY-MM-DD")}
                    disabled
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="payment_mode">Payment Mode </label>
                  <input
                    type="text"
                    className="form-control"
                    id="payment_mode_id"
                    value={
                      config.paymentMode.find(
                        (p) => p.value == expense.payment_mode_id
                      )?.label || "N/A"
                    }
                    disabled
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="narration">Narration</label>
                  <input
                    type="text"
                    className="form-control"
                    id="narration"
                    value={expense.narration}
                    disabled
                  />
                </div>
                {user.role_id != 3 && user.role_id != 4 && (
                  <div className="col-md-3">
                    <label htmlFor="branch_name">Branch Name</label>

                    <input
                      type="text"
                      className="form-control"
                      id="branch_name"
                      value={expense?.mst_branch?.branch_name}
                      disabled
                    />
                  </div>
                )}
                {/* {expense?.exp_type ==3  && <div className="col-md">
                    <label htmlFor="narration">Balance amount</label>
                    <input
                      type="text"
                      className="form-control"
                      id="cashier_name"
                      value={expense?.balance_amt}
                      disabled
                    />
                  </div>
                } */}{" "}
                {/* {expense?.exp_type ==3  && <div className="col-md">
                    <label htmlFor="narration">Balance amount</label>
                    <input
                      type="text"
                      className="form-control"
                      id="cashier_name"
                      value={expense?.balance_amt}
                      disabled
                    />
                  </div>
                } */}
                <div className="col-12">
                  <table
                    className="table mt-3 mb-5 rounded"
                    cellPadding="0"
                    cellSpacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Expense Description</th>
                        {/*<th>*/}
                        {/*    Qty*/}
                        {/*</th>*/}
                        {/*<th>*/}
                        {/*    Rate*/}
                        {/*</th>*/}
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {expense.exp_dtl &&
                        expense.exp_dtl.map((v, i) => (
                          // <tr key={`il_` + v} data-id={v}>
                          <tr key={i}>
                            <td className="w-75">
                              <input
                                type="text"
                                className="form-control"
                                name="item_name"
                                disabled
                                value={v.item_name}
                              />
                            </td>
                            {/*<td>*/}
                            {/*    <input*/}
                            {/*        type="text"*/}
                            {/*        className="form-control text-end"*/}
                            {/*        name="qty"*/}
                            {/*        value={parseFloat(v?.qty || 0).toFixed(2)}*/}
                            {/*        disabled*/}
                            {/*    />*/}
                            {/*</td>*/}
                            {/*<td>*/}
                            {/*    <input*/}
                            {/*        type="text"*/}
                            {/*        className="form-control text-end"*/}
                            {/*        name="rate"*/}
                            {/*        value={parseFloat(v?.rate || 0).toFixed(2)}*/}
                            {/*        disabled*/}
                            {/*    />*/}
                            {/*</td>*/}

                            <td>
                              <input
                                type="text"
                                className="form-control text-end"
                                name="amount"
                                value={millionComma(v?.amount)}
                                disabled
                              />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                <div className="col-12">
                  <div
                    className="row rounded px-2 py-3"
                    style={{ background: "#F4F7FE" }}
                  >
                    <div className="col-3">
                      <label htmlFor="totalRef">Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="totalRef"
                        value={millionComma(expense?.amount)}
                        disabled
                      />
                    </div>
                    <div className="col d-flex mt-auto justify-content-end gap-2">
                      <div
                        style={{
                          border: "1px solid gray",
                          height: "37px",
                          minWidth: "200px",
                          borderRadius: "5px",
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <b className="me-2"> {getPaymentMode()} </b> :{" "}
                        {millionComma(expense?.amount)}
                      </div>
                      {expense?.exp_type != 3 && (
                        <BiCreditCard
                          size={32}
                          className="text-primary mt-1"
                          role="button"
                          onClick={handlePayDtl}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </main>
        </div>
      </div>

      {showPayDtl && (
        <PayDtlCard
          cardMode="view"
          showPayDtl={showPayDtl}
          handlePayDtl={handlePayDtl}
          formInputs={formInputs}
          setFormInputs={setFormInputs}
          grossTotal={expense?.amount}
          // grossInputs={totalAtm}
        />
      )}
    </>
  );
}

export default ExpenseView;
